const hi = {
  nav: {
    login: 'लॉगिन',
    bookNow: 'अभी बुक करें',
    dashboard: 'डैशबोर्ड',
    back: 'वापस',
    home: 'होम',
  },
  landing: {
    heroTitle1: 'आसमान की ऊँचाइयों का सफर,',
    heroTitle2: 'अब आसान',
    heroSubtitle: 'भारत का प्रमुख हेलीकॉप्टर चार्टर एग्रीगेटर। सत्यापित ऑपरेटरों से जुड़ें, तुरंत उड़ानें बुक करें, और आसमान की ऊँचाइयों को छुएं।',
    bookYourFlight: 'अपनी उड़ान बुक करें',
    becomeOperator: 'ऑपरेटर बनें',
    whyChoose: 'AirYatra ही क्यों चुनें?',
    verifiedOperators: 'सत्यापित ऑपरेटर',
    verifiedOperatorsDesc: 'सभी ऑपरेटर AOC प्रमाणपत्र, बीमा और सुरक्षा अनुपालन के साथ पूर्ण रूप से सत्यापित हैं।',
    bestPrices: 'सर्वोत्तम मूल्य',
    bestPricesDesc: 'AI-संचालित मूल्य सुझाव आपको कई ऑपरेटरों से प्रतिस्पर्धी कोटेशन दिलाते हैं।',
    seamlessBooking: 'सहज बुकिंग',
    seamlessBookingDesc: 'कोटेशन अनुरोध से लेकर डिजिटल टिकट तक, अपनी पूरी यात्रा एक ही प्लेटफॉर्म पर प्रबंधित करें।',
    flightsCompleted: 'उड़ानें पूर्ण',
    verifiedOperatorsStat: 'सत्यापित ऑपरेटर',
    safetyRecord: 'सुरक्षा रिकॉर्ड',
    customerRating: 'ग्राहक रेटिंग',
    premiumServices: 'प्रीमियम सेवाएं',
    elevateExperience: 'अपने अनुभव को बेहतर बनाएं',
    premiumSubtitle: 'हमारी प्रीमियम सदस्यता और कॉर्पोरेट यात्रा समाधानों के साथ विशेष लाभ पाएं',
    blackDesc: '20% तक छूट, प्राथमिकता बुकिंग, समर्पित पायलट और विशेष लाउंज एक्सेस के साथ प्रीमियम सदस्यता।',
    priorityQueue: 'प्राथमिकता बुकिंग कतार',
    dedicatedManager: 'समर्पित रिलेशनशिप मैनेजर',
    freeCancellation: 'मुफ्त रद्दीकरण',
    exploreMembership: 'सदस्यता देखें',
    corporateConsole: 'कॉर्पोरेट कंसोल',
    corporateDesc: 'अनुमोदन वर्कफ़्लो, बजट और समेकित बिलिंग के साथ उद्यमों के लिए केंद्रीकृत यात्रा प्रबंधन।',
    employeeManagement: 'कर्मचारी प्रबंधन',
    budgetControls: 'बजट नियंत्रण',
    travelAnalytics: 'यात्रा विश्लेषण',
    corporateRegistration: 'कॉर्पोरेट पंजीकरण',
    documentVault: 'दस्तावेज़ वॉल्ट',
    vaultDesc: 'DGCA दस्तावेज़ों, बीमा, लाइसेंस के लिए सुरक्षित एन्क्रिप्टेड स्टोरेज - समाप्ति अलर्ट और वर्ज़न कंट्रोल के साथ।',
    encryption: 'AES-256 एन्क्रिप्शन',
    expiryReminders: 'समाप्ति रिमाइंडर',
    secureSharing: 'सुरक्षित साझाकरण',
    openVault: 'वॉल्ट खोलें',
    loginToAccess: 'एक्सेस के लिए लॉगिन करें',
    readyTakeOff: 'उड़ान भरने के लिए तैयार?',
    ctaSubtitle: 'आज ही अपना हेलीकॉप्टर चार्टर बुक करें और विमानन उत्कृष्टता का अनुभव करें।',
    startBooking: 'बुकिंग शुरू करें',
    footerText: '© 2025 AirYatra. सर्वाधिकार सुरक्षित। भारत का प्रमुख हेलीकॉप्टर चार्टर प्लेटफॉर्म।',
  },
  booking: {
    title: 'अपनी उड़ान बुक करें',
    subtitle: 'AirYatra - प्रीमियम एयर मोबिलिटी सेवाएं',
    previous: 'पिछला',
    next: 'अगला',
    loginPrompt: 'बुकिंग पूछताछ के लिए कृपया लॉगिन करें',
    loginBtn: 'लॉगिन करें',
    steps: {
      passengers: 'यात्री',
      booking_type: 'बुकिंग प्रकार',
      route: 'मार्ग',
      price_inquiry: 'मूल्य',
    },
  },
  bookingForm: {
    selectAircraftType: 'विमान प्रकार चुनें',
    maxPassengers: 'अधिकतम {{count}} यात्री',
    adultPassengers: 'वयस्क यात्री',
    male: 'पुरुष',
    female: 'महिला',
    totalAdults: 'कुल वयस्क',
    children: 'बच्चे (4 साल तक)',
    childrenFree: 'मुफ्त - अधिकतम 2 बच्चे',
    flightType: 'उड़ान का प्रकार',
    selectOption: '-- चुनें --',
    bookingFor: 'बुकिंग किसके लिए',
    bookingPurpose: 'बुकिंग का उद्देश्य',
    selected: 'चयनित',
    specifyPurpose: 'उद्देश्य बताएं',
    pickupLocation: 'पिकअप स्थान',
    selectPickupPoint: 'पिकअप पॉइंट चुनें',
    dropLocation: 'ड्रॉप स्थान',
    selectDropPoint: 'ड्रॉप पॉइंट चुनें',
    estimatedDistance: 'अनुमानित दूरी',
    villageDocsTitle: 'गांव लैंडिंग - दस्तावेज़ आवश्यक',
    villageDocsDesc: 'गांव/निजी जमीन पर लैंडिंग के लिए आपको Authority से निम्न दस्तावेज़ लेने होंगे:',
    villageDocsNote: 'बुकिंग कन्फर्म होने के बाद, आपको ये दस्तावेज़ अपलोड करने होंगे। Admin/Operator सत्यापित करेंगे, तभी पायलट उड़ान भरेगा।',
    departureDate: 'प्रस्थान तारीख',
    pickupTime: 'पिकअप समय',
    additionalOptions: 'अतिरिक्त विकल्प (वैकल्पिक)',
    waitingTime: 'प्रतीक्षा समय (मिनट)',
    waitingTimeNote: 'पहले 30 मिनट मुफ्त, फिर शुल्क लागू',
    nightHalts: 'रात्रि ठहराव',
    nightHaltsNote: 'क्रू आवास शुल्क शामिल',
    bookingSummary: 'बुकिंग सारांश',
    aircraftTypeLabel: 'विमान प्रकार:',
    totalPassengersLabel: 'कुल यात्री:',
    adults: 'वयस्क',
    childrenLabel: 'बच्चे',
    flightTypeLabel: 'उड़ान प्रकार:',
    pickupLabel: 'पिकअप:',
    dropLabel: 'ड्रॉप:',
    distanceLabel: 'दूरी:',
    dateTimeLabel: 'तारीख और समय:',
    at: 'को',
    villageApprovalTitle: 'गांव लैंडिंग - एडमिन अप्रूवल आवश्यक',
    villageApprovalDesc: 'आपकी इंक्वायरी एडमिन अप्रूवल के लिए भेजी जाएगी। अप्रूवल के बाद पेमेंट enabled होगी।',
    priceBreakdown: 'मूल्य विवरण',
    baseFlightCost: 'उड़ान लागत',
    flightCost: 'उड़ान लागत',
    positioningCost: 'पोज़िशनिंग लागत (डेड-लेग)',
    roundTripDiscount: 'राउंड ट्रिप छूट',
    operatorGrossCost: 'ऑपरेटर सकल लागत',
    additionalCharges: 'अतिरिक्त शुल्क',
    waitingGroundHolding: 'प्रतीक्षा / ग्राउंड होल्डिंग',
    nightHalt: 'रात्रि ठहराव ({{count}} रातें)',
    crewAccommodation: 'क्रू आवास और भोजन',
    fuelSurcharge: 'ईंधन अधिभार',
    platformFees: 'प्लेटफॉर्म शुल्क',
    convenienceFee: 'सुविधा शुल्क',
    insurance: 'बीमा',
    peakSurge: 'पीक सीज़न सर्ज',
    platformCommission: 'प्लेटफॉर्म कमीशन',
    included: 'शामिल',
    helipadCharges: 'हेलीपैड लैंडिंग शुल्क',
    totalLandingCharges: 'कुल लैंडिंग शुल्क',
    taxableAmount: 'कर योग्य राशि',
    totalGst: 'कुल GST',
    grandTotal: 'कुल राशि',
    inclusiveTaxes: 'सभी करों सहित',
    operatorReceives: 'ऑपरेटर को मिलेगा',
    specialRequirements: 'विशेष आवश्यकताएं (वैकल्पिक)',
    specialRequirementsPlaceholder: 'कोई विशेष अनुरोध या आवश्यकताएं...',
    submitting: 'भेजा जा रहा है...',
    submitApproval: 'अनुमति के लिए भेजें',
    generateInquiry: 'इंक्वायरी भेजें',
    approvalNote: 'गांव लैंडिंग के लिए एडमिन अप्रूवल जरूरी है।',
    inquiryNote: 'इंक्वायरी के बाद, ऑपरेटर्स आपको कोट भेजेंगे।',
    formRestored: 'फॉर्म डाटा बहाल किया गया!',
    selectAircraftError: 'कृपया विमान प्रकार चुनें',
    minAdultError: 'कम से कम 1 वयस्क यात्री आवश्यक',
    maxChildrenError: 'अधिकतम 2 बच्चे ही मान्य हैं',
    selectFlightTypeError: 'कृपया उड़ान प्रकार चुनें',
    selectBookingForError: 'कृपया चुनें बुकिंग किसके लिए है',
    selectPurposeError: 'कृपया बुकिंग उद्देश्य चुनें',
    selectPickupError: 'कृपया पिकअप स्थान चुनें',
    selectDropError: 'कृपया ड्रॉप स्थान चुनें',
    selectDateError: 'कृपया प्रस्थान तारीख चुनें',
    selectTimeError: 'कृपया पिकअप समय चुनें',
    priceWaitError: 'मूल्य गणना नहीं हुई! कृपया प्रतीक्षा करें',
    inquirySubmitted: 'इंक्वायरी जमा! ऑपरेटर जल्द जवाब देंगे',
    noteVillageApproval: 'गांव लैंडिंग के लिए एडमिन अनुमति जरूरी',
    notePriceEngine: 'एविएशन-ग्रेड प्राइसिंग इंजन द्वारा गणना',
    noteFinalPrice: 'अंतिम मूल्य ऑपरेटर द्वारा पुष्टि होगी',
    docCollectorNoc: 'कलेक्टर NOC',
    docFireDept: 'फायर विभाग की पावती',
    docPoliceStation: 'स्थानीय थाना की पावती',
    docSpDcp: 'SP/DCP की पावती',
  },
  options: {
    helicopter: 'हेलीकॉप्टर',
    chartered_plane: 'चार्टर्ड प्लेन',
    one_hour: '1 घंटे की उड़ान',
    two_hour: '2 घंटे की उड़ान',
    half_day: 'आधा दिन',
    full_day: 'पूरा दिन',
    multi_city: 'बहु-शहर',
    point_to_point: 'पॉइंट-टू-पॉइंट',
    self: 'खुद के लिए',
    friend_family: 'दोस्त और परिवार',
    company: 'कंपनी / कॉर्पोरेट',
    political: 'राजनीतिक / VIP',
    other: 'अन्य',
    wedding: 'शादी',
    temple_yatra: 'मंदिर यात्रा',
    company_tour: 'कॉर्पोरेट टूर',
    election_tour: 'चुनाव प्रचार',
    medical_emergency: 'मेडिकल इमरजेंसी',
    film_shooting: 'फिल्म शूटिंग',
    general_tour: 'सामान्य यात्रा',
    pilgrimage: 'तीर्थ यात्रा',
    business: 'बिज़नेस मीटिंग',
  },
};

export default hi;
